import styled, { css } from 'styled-components';
import { getOr } from 'lodash/fp';
import Modal from 'react-modal';

import breakpoints, { breakpointsDesktopFirst } from '../../themes/breakpoints';

const modalPadding = '0 0 2px 0';

const sizedCss = sizeMap => ({ size }) => sizeMap[size];

export const ResponsiveModal = styled(Modal)`
position: absolute;
${sizedCss({
    large: css`width: 960px;`,
  })}
${sizedCss({
    large: css`height: 90vh;`,
  })}
max-height: 80vh;
max-width: 80vw;
background-color: white;
padding: ${modalPadding};
border-radius: 10px;

top: 50%;
left: 50%;
transform: translate(-50%, -50%);

@media ${breakpointsDesktopFirst.tablet} {
  padding-bottom: 70px;
}

@media ${breakpoints.desktopSmall} {
  max-height: 90vh;
${sizedCss({
    large: css`min-height: 820px;`,
  })}
}
`;

export const Title = styled.div`
  font-size: 1.1rem;
  line-height: 3rem;
  vertical-align: center;
  font-weight: bold;
  text-align: left;
  width:100%;
  border-bottom: 1px solid #E2E2E2;
  padding-left: 2rem;
  display: flex;
  justify-content: space-between;
`;

export const CloseButton = styled.div`
    width: 36px;
    height: 36px;
    margin-top: 4px;
    margin-right: 4px;
    cursor: pointer;
    font-weight: 400;
`;

export const Flex = styled.div`
display: flex;
flex-direction: ${getOr('row', 'direction')};
justify-content: ${getOr('flex-start', 'justify')};
align-items: ${getOr('stretch', 'align')};
`;
